export { default as AuthWrapper } from './AuthWrapper';
export { default as EmailForm } from './RegisterForm/Email';
export { default as OtherDetail } from './RegisterForm/OtherDetails';
export { default as UserDetail } from './RegisterForm/UserDetail';
export { default as UserForm } from './UserForm';
